import { createContext } from "react";

export const FormContext = createContext({
  errors: {},
  updateValue: () => {},
  onChange: () => {},
  getValue: () => {},
  setValue: () => {}
});
